/* recovered from production bundle — store/workspace */
// @ts-nocheck

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { isLiteEdition } from '../lib/config';

let Qf = 0;
let tabInstanceSeq = 0;
const LITE_BLOCKED_TAB_TYPES = new Set([
  'scheduledJobs',
  'queryStore',
  'dpaHome',
  'dpaDrill',
  'dpaObservability',
  'dbToolBox',
  'queryDetail',
  'waitDetail',
  'osTerminal',
  'dbaOps',
]);
const isAllowedTab = tab => !isLiteEdition || !LITE_BLOCKED_TAB_TYPES.has(tab?.type);
const nC = e => {
  if (e.tabInstanceId) return `inst:${e.tabInstanceId}`;
  return e.type === "sql" ? `${e.type}|${e.connectionId}|${e.database ?? ""}|${e.title}|${e.savedQueryId ?? ""}` : e.type === "dataDiff" ? `${e.type}|${e.connectionId}|${e.title}` : `${e.type}|${e.connectionId}|${e.database ?? ""}|${e.table ?? ""}|${e.category ?? ""}|${e.routineName ?? ""}|${e.viewName ?? ""}`;
};
function WF(e) {
  for (const t of e) {
    const n = /^tab-(\d+)$/.exec(t.id);
    if (n) {
      Qf = Math.max(Qf, parseInt(n[1], 10));
    }
    const ti = /^ti-(\d+)/.exec(String(t.tabInstanceId ?? ''));
    if (ti) {
      tabInstanceSeq = Math.max(tabInstanceSeq, parseInt(ti[1], 10));
    }
  }
}
function nextTabInstanceId() {
  const seq = ++tabInstanceSeq;
  return `ti-${seq}-${Date.now().toString(36)}`;
}
function $F(e) {
  return {
    expandedConns: [...e.expandedConns],
    expandedDbs: [...e.expandedDbs],
    expandedCategories: [...e.expandedCategories],
    expandedTables: [...e.expandedTables],
    expandedTableParts: [...e.expandedTableParts],
    expandedSidebarGroups: [...e.expandedSidebarGroups]
  };
}

export const useWorkspaceStore = create(persist((e, t) => ({
  selectedConnId: null,
  selectedDb: null,
  tabs: [],
  activeTabId: null,
  splitTabId: null,
  splitRatio: 0.5,
  sidebarWidth: 280,
  sidebarCollapsed: false,
  expandedConns: new Set(),
  expandedDbs: new Set(),
  expandedCategories: new Set(),
  expandedTables: new Set(),
  expandedTableParts: new Set(),
  expandedSidebarGroups: new Set(),
  tableInfoCache: {},
  selectConn: n => e({
    selectedConnId: n
  }),
  selectDb: n => e({
    selectedDb: n
  }),
  setSidebarWidth: n => e({
    sidebarWidth: n
  }),
  setSidebarCollapsed: n => e({
    sidebarCollapsed: !!n
  }),
  toggleSidebar: () => e(r => ({
    sidebarCollapsed: !r.sidebarCollapsed
  })),
  toggleConn: n => e(r => {
    const s = new Set(r.expandedConns);
    if (s.has(n)) {
      s.delete(n);
    } else {
      s.add(n);
    }
    return {
      expandedConns: s
    };
  }),
  closeConn: n => e(r => {
    const s = new Set(r.expandedConns);
    s.delete(n);
    const prefix = n + ":";
    return {
      expandedConns: s,
      expandedDbs: new Set([...r.expandedDbs].filter(x => !x.startsWith(prefix))),
      expandedCategories: new Set([...r.expandedCategories].filter(x => !x.startsWith(prefix))),
      expandedTables: new Set([...r.expandedTables].filter(x => !x.startsWith(prefix))),
      expandedTableParts: new Set([...r.expandedTableParts].filter(x => !x.startsWith(prefix))),
      selectedConnId: r.selectedConnId === n ? null : r.selectedConnId,
      selectedDb: r.selectedConnId === n ? null : r.selectedDb
    };
  }),
  toggleDb: n => e(r => {
    const s = new Set(r.expandedDbs);
    if (s.has(n)) {
      s.delete(n);
    } else {
      s.add(n);
    }
    return {
      expandedDbs: s
    };
  }),
  toggleCategory: n => e(r => {
    const s = new Set(r.expandedCategories);
    if (s.has(n)) {
      s.delete(n);
    } else {
      s.add(n);
    }
    return {
      expandedCategories: s
    };
  }),
  toggleTable: n => e(r => {
    const s = new Set(r.expandedTables);
    if (s.has(n)) {
      s.delete(n);
    } else {
      s.add(n);
    }
    return {
      expandedTables: s
    };
  }),
  toggleTablePart: n => e(r => {
    const s = new Set(r.expandedTableParts);
    if (s.has(n)) {
      s.delete(n);
    } else {
      s.add(n);
    }
    return {
      expandedTableParts: s
    };
  }),
  toggleSidebarGroup: n => e(r => {
    const s = new Set(r.expandedSidebarGroups);
    if (s.has(n)) {
      s.delete(n);
    } else {
      s.add(n);
    }
    return {
      expandedSidebarGroups: s
    };
  }),
  openTab: n => {
    if (!isAllowedTab(n)) return null;
    const forceNew = !!n.forceNew;
    const { forceNew: _fn, ...payload } = n;
    const tab = forceNew
      ? { ...payload, tabInstanceId: nextTabInstanceId() }
      : payload;
    if (!forceNew) {
      const r = t().tabs.find(i => nC(i) === nC(tab));
      if (r) {
        e({
          activeTabId: r.id
        });
        return r.id;
      }
    }
    const s = `tab-${++Qf}`;
    e(i => ({
      tabs: [...i.tabs, {
        ...tab,
        id: s
      }],
      activeTabId: s
    }));
    return s;
  },
  closeTab: n => e(r => {
    var a;
    var l;
    const s = r.tabs.filter(E => E.id !== n);
    let i = r.activeTabId;
    if (i === n) {
      const E = r.tabs.findIndex(u => u.id === n);
      i = ((a = s[E]) == null ? undefined : a.id) ?? ((l = s[s.length - 1]) == null ? undefined : l.id) ?? null;
    }
    const splitTabId = r.splitTabId === n ? null : r.splitTabId;
    return {
      tabs: s,
      activeTabId: i,
      splitTabId
    };
  }),
  setActiveTab: n => e({
    activeTabId: n
  }),
  setSplit: n => e(r => {
    if (!n) return { splitTabId: null };
    if (r.tabs.length < 2) return {};
    // Splitting the active tab: pin it as the split pane and make another tab the main one,
    // so both stay visible side by side.
    if (n === r.activeTabId) {
      const other = r.tabs.find(x => x.id !== n);
      return { splitTabId: n, activeTabId: other ? other.id : r.activeTabId };
    }
    return { splitTabId: n };
  }),
  clearSplit: () => e({
    splitTabId: null
  }),
  setSplitRatio: n => e({
    splitRatio: Math.max(0.15, Math.min(0.85, n))
  }),
  moveTab: (fromId, toId) => e(r => {
    if (fromId === toId) return {};
    const fromIdx = r.tabs.findIndex(x => x.id === fromId);
    const toIdx = r.tabs.findIndex(x => x.id === toId);
    if (fromIdx < 0 || toIdx < 0) return {};
    const next = [...r.tabs];
    const [moved] = next.splice(fromIdx, 1);
    // drop before the target; if dragging forward, target shifted left after removal
    const insertIdx = fromIdx < toIdx ? toIdx - 1 : toIdx;
    next.splice(insertIdx, 0, moved);
    return { tabs: next };
  }),
  updateTab: (n, r) => e(s => ({
    tabs: s.tabs.map(i => i.id === n ? {
      ...i,
      ...r
    } : i)
  })),
  updateTabPanelState: (n, r, s) => e(i => ({
    tabs: i.tabs.map(a => a.id === n ? {
      ...a,
      panelState: {
        ...a.panelState,
        [r]: s
      }
    } : a)
  })),
  cacheTableInfo: (n, r, s, i) => e(a => ({
    tableInfoCache: {
      ...a.tableInfoCache,
      [`${n}:${r}:${s}`]: i
    }
  }))
}), {
  name: "dbtoolbox_workspace_v1",
  storage: createJSONStorage(() => localStorage),
  partialize: e => ({
    selectedConnId: e.selectedConnId,
    selectedDb: e.selectedDb,
    tabs: e.tabs,
    activeTabId: e.activeTabId,
    splitTabId: e.splitTabId,
    splitRatio: e.splitRatio,
    sidebarWidth: e.sidebarWidth,
    sidebarCollapsed: e.sidebarCollapsed,
    ...$F(e)
  }),
  merge: (e, t) => {
    try {
      const n = e;
      if (n && typeof n === 'object') {
        const persistedTabs = (Array.isArray(n.tabs) ? n.tabs : []).filter(isAllowedTab);
        const persistedIds = new Set(persistedTabs.map(tab => tab.id));
        WF(persistedTabs);
        return {
          ...t,
      selectedConnId: n.selectedConnId ?? t.selectedConnId,
      selectedDb: n.selectedDb ?? t.selectedDb,
      tabs: persistedTabs,
      activeTabId: persistedIds.has(n.activeTabId) ? n.activeTabId : (persistedTabs[0]?.id ?? null),
      splitTabId: persistedIds.has(n.splitTabId) ? n.splitTabId : null,
      splitRatio: typeof n.splitRatio === 'number' ? n.splitRatio : 0.5,
      sidebarWidth: (typeof n.sidebarWidth === 'number' && n.sidebarWidth > 0) ? n.sidebarWidth : t.sidebarWidth,
      sidebarCollapsed: typeof n.sidebarCollapsed === 'boolean' ? n.sidebarCollapsed : t.sidebarCollapsed,
          expandedConns: new Set(Array.isArray(n.expandedConns) ? n.expandedConns : []),
          expandedDbs: new Set(Array.isArray(n.expandedDbs) ? n.expandedDbs : []),
          expandedCategories: new Set(Array.isArray(n.expandedCategories) ? n.expandedCategories : []),
          expandedTables: new Set(Array.isArray(n.expandedTables) ? n.expandedTables : []),
          expandedTableParts: new Set(Array.isArray(n.expandedTableParts) ? n.expandedTableParts : []),
          expandedSidebarGroups: new Set(Array.isArray(n.expandedSidebarGroups) ? n.expandedSidebarGroups : []),
          tableInfoCache: {}
        };
      }
    } catch (_) {
      // If persisted state is corrupt, start fresh
    }
    return t;
  }
}));

/** Always opens a new SQL editor tab (right-click New Query, header, etc.). */
export function openNewSqlTab(opts: {
  connectionId: string;
  database?: string | null;
  sql?: string;
  title?: string;
  editorMode?: string;
  builderTable?: string;
  savedQueryId?: string;
}) {
  const store = useWorkspaceStore.getState();
  const db = opts.database ?? '';
  const base = db ? `Query · ${db}` : 'Query';
  const count = store.tabs.filter(
    (t) => t.type === 'sql' && t.connectionId === opts.connectionId && (t.database ?? '') === db,
  ).length;
  const title = opts.title ?? (count > 0 ? `${base} ${count + 1}` : base);
  return store.openTab({
    type: 'sql',
    title,
    connectionId: opts.connectionId,
    database: opts.database ?? undefined,
    sql: opts.sql ?? '',
    savedQueryId: opts.savedQueryId,
    editorMode: opts.editorMode,
    builderTable: opts.builderTable,
    forceNew: true,
  });
}

/** Always opens Query Store in a new tab. */
export function openQueryStoreTab(opts: {
  connectionId: string;
  connectionName?: string;
  title?: string;
}) {
  const store = useWorkspaceStore.getState();
  const name = opts.connectionName ?? opts.connectionId.slice(0, 8);
  const count = store.tabs.filter(
    (t) => t.type === 'queryStore' && t.connectionId === opts.connectionId,
  ).length;
  const title = opts.title ?? (count > 0 ? `Query Store · ${name} (${count + 1})` : `Query Store · ${name}`);
  return store.openTab({
    type: 'queryStore',
    title,
    connectionId: opts.connectionId,
    connectionName: opts.connectionName,
    forceNew: true,
  });
}

/** Opens a Group Query tab: runs one read-only SQL across every connection in a group. */
export function openGroupQueryTab(opts: {
  groupId: string;
  groupName: string;
  sql?: string;
  title?: string;
}) {
  const store = useWorkspaceStore.getState();
  const base = `Group Query · ${opts.groupName}`;
  const count = store.tabs.filter((t) => t.type === 'groupQuery' && t.groupId === opts.groupId).length;
  const title = opts.title ?? (count > 0 ? `${base} (${count + 1})` : base);
  return store.openTab({
    type: 'groupQuery',
    title,
    groupId: opts.groupId,
    groupName: opts.groupName,
    sql: opts.sql ?? '',
    forceNew: true,
  });
}

/** Always opens DPA Observability in a new tab (Fleet, sidebar, etc.). */
export function openDpaObservabilityTab(opts: {
  connectionId: string;
  connectionName?: string;
  title?: string;
  initialTab?: string;
}) {
  const store = useWorkspaceStore.getState();
  const rawName = opts.connectionName ?? opts.connectionId.slice(0, 8);
  const name = String(rawName).replace(/^(mysql|pg):/, '').trim();
  const count = store.tabs.filter(
    (t) => t.type === 'dpaObservability' && t.connectionId === opts.connectionId,
  ).length;
  const base = opts.title ?? `DPA · ${name}`;
  const title = count > 0 ? `${base} (${count + 1})` : base;
  return store.openTab({
    type: 'dpaObservability',
    title,
    connectionId: opts.connectionId,
    connectionName: opts.connectionName ?? name,
    initialTab: opts.initialTab,
    forceNew: true,
  });
}

/** Opens the unified DB Tool Box screen for a connection in a new tab. */
export function openDbToolBoxTab(opts: {
  connectionId: string;
  connectionName?: string;
  title?: string;
  dpaTab?: string;
}) {
  const store = useWorkspaceStore.getState();
  const rawName = opts.connectionName ?? opts.connectionId.slice(0, 8);
  const name = String(rawName).replace(/^(mysql|pg):/, '').trim();
  const count = store.tabs.filter(
    (t) => t.type === 'dbToolBox' && t.connectionId === opts.connectionId,
  ).length;
  const base = opts.title ?? `DB Tool Box · ${name}`;
  const title = count > 0 ? `${base} (${count + 1})` : base;
  return store.openTab({
    type: 'dbToolBox',
    title,
    connectionId: opts.connectionId,
    connectionName: opts.connectionName ?? name,
    dpaTab: opts.dpaTab,
    forceNew: true,
  });
}

/** Focus existing DPA Fleet tab or open one. */
export function openDpaHomeTab() {
  const store = useWorkspaceStore.getState();
  const existing = store.tabs.find((t) => t.type === 'dpaHome');
  if (existing) {
    store.setActiveTab(existing.id);
    return existing.id;
  }
  return store.openTab({ type: 'dpaHome', title: 'DPA Home' });
}

/** Opens instance drill-down (Fleet click) in a new tab. */
export function openDpaDrillTab(opts: {
  connectionId: string;
  connectionName?: string;
  dpaTab?: string;
  title?: string;
}) {
  const store = useWorkspaceStore.getState();
  const rawName = opts.connectionName ?? opts.connectionId.slice(0, 8);
  const name = String(rawName).replace(/^(mysql|pg):/, '').trim();
  const count = store.tabs.filter(
    (t) => t.type === 'dpaDrill' && t.connectionId === opts.connectionId,
  ).length;
  const base = opts.title ?? `DPA · ${name}`;
  const title = count > 0 ? `${base} (${count + 1})` : base;
  return store.openTab({
    type: 'dpaDrill',
    title,
    connectionId: opts.connectionId,
    connectionName: opts.connectionName ?? name,
    dpaTab: opts.dpaTab ?? 'sql',
    forceNew: true,
  });
}

/** Focus existing Process List tab for connection or open one. */
export function openProcessListTab(opts: {
  connectionId: string;
  connectionName?: string;
}) {
  const store = useWorkspaceStore.getState();
  const name = opts.connectionName ?? opts.connectionId.slice(0, 8);
  return store.openTab({
    type: 'process',
    title: 'Processes',
    connectionId: opts.connectionId,
    connectionName: name,
  });
}

/** Opens the Backup action as a main-panel tab (replaces the floating modal). */
export function openBackupTab(opts: {
  connectionId: string;
  connectionName?: string;
  database?: string | null;
  objects?: unknown;
  title?: string;
}) {
  const store = useWorkspaceStore.getState();
  const name = opts.connectionName ?? opts.connectionId.slice(0, 8);
  const base = opts.title ?? `Backup — ${name}`;
  return store.openTab({
    type: 'backup',
    title: base,
    connectionId: opts.connectionId,
    database: opts.database ?? undefined,
    objects: opts.objects,
    forceNew: true,
  });
}

/** Opens the (legacy) Restore action as a main-panel tab. */
export function openRestoreTab(opts: {
  sourceConnectionId: string;
  sourceConnectionName?: string;
  sourceDatabase?: string | null;
  filePath?: string;
  backupId?: string;
  title?: string;
}) {
  const store = useWorkspaceStore.getState();
  const name = opts.sourceConnectionName ?? opts.sourceConnectionId.slice(0, 8);
  const base = opts.title ?? `Restore — ${name}`;
  return store.openTab({
    type: 'restore',
    title: base,
    sourceConnectionId: opts.sourceConnectionId,
    sourceDatabase: opts.sourceDatabase ?? undefined,
    filePath: opts.filePath,
    backupId: opts.backupId,
    forceNew: true,
  });
}

/** Opens the Smart Restore (DBTB2) action as a main-panel tab. */
export function openSmartRestoreTab(opts: {
  sourceConnectionId: string;
  sourceConnectionName?: string;
  backupId: string;
  sourceDatabase?: string | null;
  title?: string;
}) {
  const store = useWorkspaceStore.getState();
  const name = opts.sourceConnectionName ?? opts.sourceConnectionId.slice(0, 8);
  const base = opts.title ?? `Smart Restore — ${name}`;
  return store.openTab({
    type: 'smartRestore',
    title: base,
    sourceConnectionId: opts.sourceConnectionId,
    backupId: opts.backupId,
    sourceDatabase: opts.sourceDatabase ?? undefined,
    forceNew: true,
  });
}

/** Opens Settings as a main-panel tab (single instance). */
export function openSettingsTab() {
  const store = useWorkspaceStore.getState();
  const existing = store.tabs.find((t) => t.type === 'settings');
  if (existing) {
    store.setActiveTab(existing.id);
    return existing.id;
  }
  return store.openTab({ type: 'settings', title: 'Settings' });
}

/** Opens Data Transfer as a main-panel tab. */
export function openDataTransferTab(opts: {
  connectionId?: string;
  database?: string | null;
  title?: string;
}) {
  const store = useWorkspaceStore.getState();
  return store.openTab({
    type: 'dataTransfer',
    title: opts.title ?? 'Data Transfer',
    connectionId: opts.connectionId,
    database: opts.database ?? undefined,
    forceNew: true,
  });
}

/** Opens New Database as a main-panel tab. */
export function openNewDatabaseTab(opts: {
  connectionId: string;
  connectionName?: string;
  title?: string;
}) {
  const store = useWorkspaceStore.getState();
  const name = opts.connectionName ?? opts.connectionId.slice(0, 8);
  const base = opts.title ?? `New Database — ${name}`;
  return store.openTab({
    type: 'newDatabase',
    title: base,
    connectionId: opts.connectionId,
    forceNew: true,
  });
}

/** Opens the New/Edit Connection form as a main-panel tab. */
export function openConnectionFormTab(opts: {
  conn?: unknown;
  title?: string;
}) {
  const store = useWorkspaceStore.getState();
  const title = opts.title ?? (opts.conn ? 'Edit Connection' : 'New Connection');
  return store.openTab({
    type: 'connectionForm',
    title,
    conn: opts.conn,
    forceNew: true,
  });
}

/** Opens the DBA Ops panel (replication / maintenance / idle sessions / backup verify) as a tab. */
export function openDbaOpsTab(opts: {
  connectionId: string;
  connectionName?: string;
  database?: string | null;
  section?: string;
  title?: string;
}) {
  if (isLiteEdition) return;
  const store = useWorkspaceStore.getState();
  const name = opts.connectionName ?? opts.connectionId.slice(0, 8);
  const base = opts.title ?? `DBA Ops — ${name}`;
  return store.openTab({
    type: 'dbaOps',
    title: base,
    connectionId: opts.connectionId,
    connectionName: name,
    database: opts.database ?? undefined,
    section: opts.section ?? 'replication',
    forceNew: true,
  });
}

/** Opens a host OS shell (PTY) as a full main-panel tab. Always new — click again
 *  for another shell session ("varias viñetas de Shell"). Admin-only at runtime. */
export function openOsTerminalTab(opts?: { title?: string }) {
  const store = useWorkspaceStore.getState();
  const count = store.tabs.filter((t) => t.type === 'osTerminal').length;
  const base = opts?.title ?? 'Shell';
  const title = count > 0 ? `${base} (${count + 1})` : base;
  return store.openTab({
    type: 'osTerminal',
    title,
    forceNew: true,
  });
}
